(function () {
    'use strict';
    angular
        .module('app.memberAdmin')
        .directive('sc3IgnMembership', sc3IgnMembership);

    var copy = angular.copy,
        noop = angular.noop;

    sc3IgnMembership.$inject = ['$timeout', 'Member', 'memberAdminResources', 'alert', 'confirm'];
    function sc3IgnMembership($timeout, Member, resources, alert, confirm) {
        return {
            require: ['sc3IgnMembership', '^^sc3IgnMembershipList', 'form'],
            restrict: 'A',
            templateUrl: 'app/member-admin/ign-membership/ign-membership.directive.html',
            scope: {
                membership: '<sc3IgnMembership'
            },
            link: link,
            controller: IgnMembershipController,
            controllerAs: '$ctrl',
            bindToController: true
        };

        function link(scope, element, attr, ctrls) {
            var sc3IgnMembership = ctrls[0],
                sc3IgnMembershipList = ctrls[1],
                form = ctrls[2];

            sc3IgnMembership.init(sc3IgnMembershipList, form, element);
        }

        function IgnMembershipController() {
            // Variables
            var ctrl = this, pristine, parent, association, element;

            // Properties
            Object.defineProperty(ctrl, 'isEditing', { get: getIsEditing });
            Object.defineProperty(ctrl, 'ignAssociations', { get: getIgnAssociations });
            Object.defineProperty(ctrl, 'association', { get: getAssociation, set: setAssociation });

            // Methods
            ctrl.init = init;
            ctrl.edit = edit;
            ctrl.remove = remove;
            ctrl.cancel = cancel;
            ctrl.save = save;

            //////////////////

            function init(parentComponent, form, elem) {
                parent = parentComponent;
                ctrl.form = form;
                element = elem;
                pristine = ctrl.membership;
                if (pristine.isNew)
                    edit();
            }

            function edit() {
                ctrl.membership = copy(pristine);
                association = ctrl.ignAssociations.find(function (x) { return x.code === pristine.nacCode });
                autoFocus();
            }
            function remove() {
                confirm(resources.confirmRemoveIgnMembership).then(remove, noop);

                function remove() {
                    Member.deleteIgnMembership({ id: parent.individualId }, ctrl.membership, success, error, true);

                    function success() {
                        parent.remove(ctrl.membership);
                    }
                    function error() {
                        alert.error(resources.deleteIgnMembershipFailed);
                    }
                }
            }
            function cancel() {
                ctrl.membership = pristine;
                if (ctrl.membership.isNew)
                    parent.remove(ctrl.membership);
            }
            function save() {
                if (ctrl.form.$valid) {
                    Member.saveIgnMembership({ id: parent.individualId }, ctrl.membership, success, error, true);
                }
                function success() {
                    ctrl.membership = copy(ctrl.membership, pristine);
                    ctrl.membership.isNew = false;
                }
                function error() {
                    alert.error(resources.saveIgnMembershipFailed);
                }
            }
            function getIsEditing() {
                return ctrl.membership !== pristine;
            }
            function getIgnAssociations() {
                return parent.ignAssociations;
            }

            function getAssociation() {
                return association;
            }

            function setAssociation(value) {
                association = value;
                ctrl.membership.nacCode = value && value.code || null;
                ctrl.membership.association = value && value.name || null;
            }

            function autoFocus() {
                // This should be a directive.
                $timeout(autoFocus, 0, false);
                function autoFocus() {
                    var target = element[0].querySelector('select:enabled,input:enabled');
                    if (target)
                        target.focus();
                }
            }
        }
    }
})();
